import { DialogTitle } from '@mui/material';

interface DialogTitleProps {
  children?: React.ReactNode;
}

export const lookoDialogHeaderClassName = 'LookoDialogHeader';

/**
 * 모달 헤더.
 */
export default function DialogHeader({ children }: DialogTitleProps) {
  return (
    <DialogTitle variant="H2_Looko" bgcolor={'black'} color={'white'} className={lookoDialogHeaderClassName}>
      {children}
    </DialogTitle>
  );
}
